import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";

const EvictionSettingsModal = ({ onClose, settingsData, updateSettings }) => {
  const [settings, setSettings] = useState(settingsData || {});

  useEffect(() => {
    setSettings(settingsData || {});
  }, [settingsData]);

  const toggleSetting = async (key) => {
    const newSettings = { ...settings, [key]: !settings[key] };

    setSettings(newSettings);

    try {
      await updateSettings(newSettings);
      // toast.success("Settings updated successfully!");
    } catch (error) {
      toast.error("Failed to update settings.");
      setSettings(settings);
    }
  };

  return (
    <div className="bg-white w-full h-full flex flex-col">
      <Header>
        {/* <Title className="text-white">Eviction Settings</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button> */}
        <h1 className="text-white text-lg font-medium">Eviction Settings</h1>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <div className="px-6 h-full flex flex-col justify-between pb-4 relative">
        <Wrapper>
          <Section>
            <SectionTitle>Settings</SectionTitle>
            <ToggleRow>
              <div>
                <Label>Auto Eviction</Label>
                <Description>
                  The tenant will be automatically evicted
                  <br />
                  on their eviction date.
                </Description>
              </div>
              <Toggle
                checked={settings.autoEviction}
                onChange={() => toggleSetting("autoEviction")}
              />
            </ToggleRow>
            {/* <ToggleRow>
              <div>
                <Label>Add Prorate Rent till eviction date</Label>
                <Description>
                  Rent will be added till the eviction date
                  <br />
                  only and not for the entire month.
                </Description>
              </div>
              <Toggle
                checked={settings.addProrateRent}
                onChange={() => toggleSetting("addProrateRent")}
              />
            </ToggleRow> */}
          </Section>
        </Wrapper>
      </div>
    </div>
  );
};

const Wrapper = tw.div`grid gap-6 my-3`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-700`;
const ToggleRow = tw.div`flex justify-between py-3 border-b border-gray-200 items-center`;
const Row = tw.div`flex justify-between py-2 items-center`;
const Label = tw.span`text-gray-900`;
const Description = tw.p` text-gray-500 text-sm md:m-1`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;

const Toggle = ({ checked, onChange }) => (
  <label className="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      className="sr-only peer"
      checked={checked}
      onChange={onChange}
    />
    <div className="w-11 h-6 bg-gray-300  rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
  </label>
);

export default EvictionSettingsModal;
